import { RefObject, useEffect, useState } from 'react'

/**
 * Reports whether `ref`'s element currently intersects the viewport by at least `threshold`
 * (0 to 1). Used by carousels to derive a single container-level visibility signal that drives
 * every card inside them together — see `CWCVideoCard`'s `shouldPlay` prop.
 */
export function useIsIntersecting(ref: RefObject<Element>, threshold: number): boolean {
  const [isIntersecting, setIsIntersecting] = useState(false)

  useEffect(() => {
    const element = ref.current
    if (!element) return undefined

    const observer = new IntersectionObserver(
      ([entry]) => setIsIntersecting(entry.isIntersecting),
      {
        threshold,
      },
    )
    observer.observe(element)
    return () => observer.disconnect()
  }, [ref, threshold])

  return isIntersecting
}
